import { cn } from "utils/helpers";

type QuestionTypeTagProps = {
	questionType: string;
};

export const QuestionTypeTag = ({ questionType }: QuestionTypeTagProps) => (
	<div
		className={cn(
			"rounded-lg bg-utility-blue-light-50 px-2 py-1 text-xs !font-medium text-utility-brand-700"
		)}
	>
		{questionType}
	</div>
);
